import '../styles/application.scss';
import '../utils/initRailsUJS';
import ReactOnRails from 'react-on-rails';

import App from '../components/App'
import ChooseAccount from '../components/ChooseAccount'
import CreateInstance from '../components/CreateInstance'
import DeleteAccount from '../components/DeleteAccount'
import DirectorsAsyncJobs from '../components/DirectorsAsyncJobs'
import DirectorsAuditTrails from '../components/DirectorsAuditTrails'
import DirectorsAccountEmails from '../components/DirectorsAccountEmails'
import DirectorsAccountShow from '../components/DirectorsAccountShow'
import DirectorsAccounts from '../components/DirectorsAccounts'
import EmailFieldForm from '../components/EmailFieldForm'
import Join from '../components/Join'
import LanguagePicker from '../components/shared/LanguagePicker'
import Login from '../components/Login'
import MyAccount from '../components/MyAccount'
import Register from '../components/Register'
import Security from '../components/Security'
import SetPasswordFieldForm from '../components/SetPasswordFieldForm'

ReactOnRails.register({
  App,
  ChooseAccount,
  CreateInstance,
  DeleteAccount,
  DirectorsAsyncJobs,
  DirectorsAuditTrails,
  DirectorsAccountEmails,
  DirectorsAccountShow,
  DirectorsAccounts,
  EmailFieldForm,
  Join,
  LanguagePicker,
  Login,
  MyAccount,
  Register,
  Security,
  SetPasswordFieldForm
});
